import type {
  ExcludeSupportGmRewardAction,
  GamificationActionContext,
  GamificationActionTarget,
} from '../types/gamificationActions';
import { GAMIFICATION_ACTION_TARGETS } from '../constants/gamificationActionTargets';

export const resolveGamificationActionTarget = (
  action: ExcludeSupportGmRewardAction,
  context: GamificationActionContext,
): GamificationActionTarget | undefined => {
  const target = GAMIFICATION_ACTION_TARGETS[action];

  if (!target) {
    return undefined;
  }

  if ('kind' in target) {
    return target;
  }

  return target.surfaceTargets[context.surface];
};
